var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUsername(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 600c28 29 61 43 100 43s72-14 100-43c29-28 43-61 43-100s-14-72-43-100c-28-29-61-43-100-43s-72 14-100 43c-29 28-43 61-43 100s14 72 43 100zM163 165C257 71 369 25 500 25s243 46 335 140c94 92 140 204 140 335v69c0 48-16 88-49 121-31 32-70 49-116 49-58 0-105-24-140-72-48 48-104 72-170 72-65 0-122-23-170-69-46-48-69-105-69-170 0-66 23-121 69-167 48-48 105-72 170-72 66 0 121 24 167 72 48 46 72 101 72 167v69c0 19 7 37 20 51 15 15 32 23 51 23 20 0 36-8 49-23 15-14 23-32 23-51v-69c0-104-38-194-114-268-74-76-164-114-268-114s-194 38-270 114c-74 74-112 164-112 268s38 194 112 270c76 74 166 112 270 112h239v93H500c-131 0-243-46-337-138C71 743 25 631 25 500s46-243 138-335z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsername);
export default __webpack_public_path__ + "static/media/ic_username.5f545fdb71494d281525fe4bd2cc61f4.svg";
export { ForwardRef as ReactComponent };